import styles from './FormWrapper.module.css';

const FormWrapper = ({ children, isSmall, mode }: any) => {
    return (
        <div
            id={'formWrapper'}
            className={`${styles.wrapper} ${isSmall ? styles.small : ''} ${mode === 'view' ? styles.view : ''}`}
        >
            {children}
        </div>
    );
};

export default FormWrapper;
